export default __webpack_public_path__ + "static/media/15.ac9d0365.jpg";